export enum BiomedicalEquipmentConnectionType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export interface BiomedicalEquipmentConfigItemDTO {
  biomedicalEquipmentConfig: number
  name: string
  aeTitle: string
  url: string
  port: number
  providerSiteCode?: string
  user: string
  password: string
  active: boolean
  connectionType: BiomedicalEquipmentConnectionType
}

export interface BiomedicalEquipmentConfigSavePayloadDTO {
  biomedicalEquipmentConfig: number | null
  name: string
  aeTitle: string
  url: string
  port: number
  providerSiteCode?: string
  user: string
  password: string
  active: boolean
  connectionType: BiomedicalEquipmentConnectionType
}

